import React from 'react';
import { useTable } from 'react-table';
import ReactSelect from '../../components/Inputs/ReactSelect';
import update from 'immutability-helper';
import styled from 'styled-components';
import PlusIcon from '../../components/Icons/solid/PlusIcon';
import XCircle from '../../components/Icons/solid/XCircle';
import { COLORS } from '../../config';

const Styles = styled.div`
  .clinic-table {
    width: 100%;
    border-collapse: collapse;
    border-radius: 30px;
    border-style: hidden;    
  }
`;

export default function ClinicAssociationTable({
  columns,
  data,
  setData,
  clinicOptions,
  selectedClinic,
  setSelectedClinic,
  allClinics,
  foundClinic,
  setFoundClinic,
  edit
}) {

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })


  const selectStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'white' : '#1a3b5c',
        backgroundColor: state.isSelected ? '#006bb7' : '',
        ':hover': {
          backgroundColor: state.isSelected ? '#006bb7' : '#006bb725',
        }
    }),
    control: (provided, state) => ({
      ...provided,
      outline: state.isFocused ? '0px solid red' : '',
      outlineOffset: state.isFocused ? '16px' : '8px',
      borderRadius: '0.25rem',
      fontSize: '0.85rem',
      lineHeight: 1,
      backgroundColor: 'none',
      borderStyle: 'none',
      boxShadow: 'none',
      height: 'auto'
    }),
    placeholder: () => ({
      color: '#9ea4b0'
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#1a3b5c',
      lineHeight: '1.25',
      marginTop: '1px'
    }),
  };
  
  
  React.useEffect(() => {
    if (!selectedClinic || !allClinics.length) return;
    const foundClinic = allClinics.find(clinic => clinic._id === selectedClinic);
    setFoundClinic(foundClinic);
  }, [selectedClinic, allClinics, setFoundClinic])


  const handleRemoveRow = (index) => {
    const newData = update(data, { $splice: [[index, 1]] });
    setData(newData);
  }

  const handleAddClinicButton = () => {
    if (!selectedClinic) return;
    setSelectedClinic(null); 
    setFoundClinic(null);
    const clinicToAdd =  {
      name: foundClinic.name,
      type: foundClinic.type,
      city: foundClinic.location.city,
      _id: foundClinic._id
    }
    setData([ ...data, clinicToAdd])
  }
  
  return (
    <Styles>
      <div>
        <table {...getTableProps()} className='clinic-table'>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps()} className='text-left text-secondary' >{column.render('Header')}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()} className='h-8 text-shade'>
                  {row.cells.map(cell => {
                    if (cell.column.id === 'name') return <td {...cell.getCellProps()} className='min-w-3/4'>{cell.render('Cell')}</td>
                    return <td {...cell.getCellProps()} className='py-2'>{cell.render('Cell')}</td>
                  })}
                  {edit && 
                  <td>
                    <XCircle className='cursor-pointer' fill={COLORS.deleteRed} onClick={() => handleRemoveRow(i)}/>
                  </td>
                  }
                </tr>
              )
            })}
            {edit && 
            <tr className='h-8 text-shade border-2 border-primary'>
              <td className='p-2'><ReactSelect options={clinicOptions} customStyles={selectStyles} value={foundClinic && foundClinic.name ? foundClinic.name : 'Add clinic'} onChange={(e) => setSelectedClinic(e.value)}/></td>
              <td className='p-2'>{(foundClinic && foundClinic.type) || ''}</td>
              <td className='p-2'>{(foundClinic && foundClinic.location && foundClinic.location.city) || ''}</td>
              <td>
                <PlusIcon circle className={selectedClinic ? `cursor-pointer` : ''} fill={selectedClinic ? COLORS.colorPrimary : 'rgba(209, 213, 219, 1)'} onClick={handleAddClinicButton}/>
              </td>
            </tr>}
          </tbody>
        </table>
      </div>
    </Styles>
  )
}